import React, { useState }from 'react';
import DashboardIcon from '@mui/icons-material/Dashboard';
import FeedIcon from '@mui/icons-material/Feed';
import LogoutIcon from '@mui/icons-material/Logout';
import SettingsIcon from '@mui/icons-material/Settings';
import { useSelector, useDispatch } from 'react-redux';
import { setFilters, resetFilters } from 'reducers/filtersSHEETSlice';
import { resetPagination } from 'reducers/paginationSHEETSlice';
import { useTranslation } from "react-i18next"
import { Link } from 'react-router-dom';
import { Navigate } from 'react-router-dom'; 
import { ToastContainer } from 'react-toastify'; 
import { TodayIs} from 'components/utils/TodayIs';
import ImportScript from 'components/utils/ImportScript';
import Footer from "pages/main/Footer";
import Alerts from 'pages/alerts/Alerts';
import Person from 'pages/main/Person';
import Messages from 'pages/messages/Messages';
import SHEETFilter from "pages/sheet/filterSHEET/SHEETFilter"
   
const HomeSHEET = (typeList) => {
    const {t,i18n} = useTranslation(['listDataForms']);
    const dispatch = useDispatch();
    const filtersSHEET = useSelector((state) => state.filtersSHEET); // Obtener filtros desde Redux
    const state = useSelector((state) => state);
    const enabled = state.loginUser.enabled;
    const roles = state.loginUser.roles;
    const defaultStore = state.loginUser.defaultStore;
    const [showModalSHEEETSettings, setshowModalSHEEETSettings] = useState(true); 
    const [typeOfList] = useState(typeList);
    const scriptUrl = '/js/sb-admin-2.min.js'; 
 
    const changeSelectedLanguage = () => {
        if (i18n.language === "es") {
            i18n.changeLanguage("en");
            dispatch(setFilters({ sheetStateFromES: "", sheetStateToES: "" }));
        } else {
            i18n.changeLanguage("es");
            dispatch(setFilters({ sheetStateFromEN: "", sheetStateToEN: "" }));
        }
    };
    
    const closeModalSHEET = () => {     
        setshowModalSHEEETSettings(showModalSHEEETSettings);
        dispatch(resetPagination());
        dispatch(resetFilters());
        return () => {};
    };
    
    return (
    <>
        <ImportScript resourceUrl={scriptUrl} />
        <ToastContainer/>
        {enabled===false ? <Navigate to="/"></Navigate>:
        <div id="page-top">
           
            {/* Page Wrapper */}
            <div id="wrapper">

                {/* Sidebar */}
                <ul className="navbar-nav bg-gradient-primary toggled sidebar sidebar-dark accordion" id="accordionSidebar">

                    {/* Sidebar - Brand */}
                    <Link className="sidebar-brand d-flex align-items-center justify-content-center" to="/home">
                        <div className="sidebar-brand-icon rotate-n-15">
                            <DashboardIcon/>
                        </div>
                        <div className="sidebar-brand-text mx-3">{t('Text_Title')}</div>
                    </Link>

                    {/* Divider */}
                    <hr className="sidebar-divider my-0"/>

                    {/* Nav Item - Dashboard */}
                    <li className="nav-item active">
                        <div className="nav-link">
                            <i className="fas fa-fw fa-tachometer-alt"></i>
                            <span>{t('Menu_Main_SHEET')}</span></div>
                    </li>

                    {/* Divider */}
                    <hr className="sidebar-divider"/>

                    {/* Sidebar - INFORMATION FILTROS APLICADOS */}
                    <li className="nav-item active">
                        <Link className="nav-link" to="/sheet">
                            <FeedIcon/>
                            <span> {t('Text_Information')}</span>
                        </Link>
                    </li>
                    <div className={filtersSHEET.idFrom===''?"sidebar-heading":"sidebar-heading text-white"}>   
                        {t('Text_Filter_Code_From')}
                    </div>
                    <li className={filtersSHEET.idFrom===''?"sidebar-heading text-warning":"sidebar-heading text-warning"}>
                        { filtersSHEET.idFrom==='' ? t('Text_Filter_Not_Apply'): filtersSHEET.idFrom}
                    </li>
                    <div className={filtersSHEET.idTo===''?"sidebar-heading":"sidebar-heading text-white"}>   
                        {t('Text_Filter_Code_To')}
                    </div>
                    <li className={filtersSHEET.idTo===''?"sidebar-heading text-warning":"sidebar-heading text-warning"}>
                        { filtersSHEET.idTo==='' ? t('Text_Filter_Not_Apply'): filtersSHEET.idTo}
                    </li> 
                    {roles[0].listmenus.find((key)=>(key.name==="SubMenu_Settings_Sheet_Store_Master"))&&
                        <>
                            <div className={filtersSHEET.defaultStoreIdFrom===''?"sidebar-heading":"sidebar-heading text-white"}>   
                                {t('Text_Filter_Stores_From')}
                            </div>
                            <li className={filtersSHEET.defaultStoreIdFrom===''?"sidebar-heading text-warning":"sidebar-heading text-warning"}>
                                { filtersSHEET.defaultStoreIdFrom==='' ? t('Text_Filter_Not_Apply'): filtersSHEET.defaultStoreIdFrom}
                            </li>
                            <div className={filtersSHEET.defaultStoreIdTo===''?"sidebar-heading":"sidebar-heading text-white"}>   
                                {t('Text_Filter_Stores_To')}
                            </div>
                            <li className={filtersSHEET.defaultStoreIdTo===''?"sidebar-heading text-warning":"sidebar-heading text-warning"}>
                                { filtersSHEET.defaultStoreIdTo==='' ? t('Text_Filter_Not_Apply'): filtersSHEET.defaultStoreIdTo}
                            </li>
                        </>
                    } 
                     
                    <div className={filtersSHEET.numberSheetFrom===''?"sidebar-heading":"sidebar-heading text-white"}>
                        {t('Text_Filter_NumberSheet_From')}
                    </div>
                    <li className={filtersSHEET.numberSheetFrom===''?"sidebar-heading text-warning":"sidebar-heading text-warning"}>
                        { filtersSHEET.numberSheetFrom==='' ? t('Text_Filter_Not_Apply'): filtersSHEET.numberSheetFrom}
                    </li>
                    <div className={filtersSHEET.numberSheetTo===''?"sidebar-heading":"sidebar-heading text-white"}>
                        {t('Text_Filter_NumberSheet_To')}
                    </div>
                    <li className={filtersSHEET.numberSheetTo===''?"sidebar-heading text-warning":"sidebar-heading text-warning"}>
                        { filtersSHEET.numberSheetTo==='' ? t('Text_Filter_Not_Apply'): filtersSHEET.numberSheetTo}
                    </li>
                    
                    <div className={filtersSHEET.dateSheetFrom===null?"sidebar-heading":"sidebar-heading text-white"}>
                        {t('Text_Filter_DateEntrySheet_From')}
                    </div>
                    <li className={filtersSHEET.dateSheetFrom===null?"sidebar-heading text-warning":"sidebar-heading text-warning"}>
                        { filtersSHEET.dateSheetFrom===null ? t('Text_Filter_Not_Apply'): new Date(filtersSHEET.dateSheetFrom).toLocaleDateString(i18n.language==="es"?'es-ES':'en-US')}
                    </li>                    
                    <div className={filtersSHEET.dateSheetTo===null?"sidebar-heading":"sidebar-heading text-white"}>
                        {t('Text_Filter_DateEntrySheet_To')}
                    </div>
                    <li className={filtersSHEET.dateSheetTo===null?"sidebar-heading text-warning":"sidebar-heading text-warning"}>
                        { filtersSHEET.dateSheetTo===null ? t('Text_Filter_Not_Apply'): new Date(filtersSHEET.dateSheetTo).toLocaleDateString(i18n.language==="es"?'es-ES':'en-US')}
                    </li>
 
                    <div className={filtersSHEET.marcaFrom===''?"sidebar-heading":"sidebar-heading text-white"}>   
                        {t('Text_Filter_MarcaSheet_From')}
                    </div>
                    <li className={filtersSHEET.marcaFrom===''?"sidebar-heading text-warning":"sidebar-heading text-warning"}>
                        { filtersSHEET.marcaFrom==='' ? t('Text_Filter_Not_Apply'): filtersSHEET.marcaFrom}
                    </li>
                    <div className={filtersSHEET.marcaTo===''?"sidebar-heading":"sidebar-heading text-white"}>   
                        {t('Text_Filter_MarcaSheet_To')}
                    </div>

                    <li className={filtersSHEET.marcaTo===''?"sidebar-heading text-warning":"sidebar-heading text-warning"}>
                        { filtersSHEET.marcaTo==='' ? t('Text_Filter_Not_Apply'): filtersSHEET.marcaTo}
                    </li>

                    <div className={filtersSHEET.modeloFrom===''?"sidebar-heading":"sidebar-heading text-white"}>   
                        {t('Text_Filter_ModelSheet_From')}
                    </div>
                    <li className={filtersSHEET.modeloFrom===''?"sidebar-heading text-warning":"sidebar-heading text-warning"}>
                        { filtersSHEET.modeloFrom==='' ? t('Text_Filter_Not_Apply'): filtersSHEET.modeloFrom}
                    </li>
                    <div className={filtersSHEET.modeloTo===''?"sidebar-heading":"sidebar-heading text-white"}>   
                        {t('Text_Filter_ModelSheet_To')}
                    </div>

                    <li className={filtersSHEET.modeloTo===''?"sidebar-heading text-warning":"sidebar-heading text-warning"}>
                        { filtersSHEET.modeloTo==='' ? t('Text_Filter_Not_Apply'): filtersSHEET.modeloTo}
                    </li>

                    <div className={filtersSHEET.licensePlateSheetFrom===''?"sidebar-heading":"sidebar-heading text-white"}>   
                        {t('Text_Filter_LicensePlateSheet_From')}
                    </div>
                    <li className={filtersSHEET.licensePlateSheetFrom===''?"sidebar-heading text-warning":"sidebar-heading text-warning"}>
                        { filtersSHEET.licensePlateSheetFrom==='' ? t('Text_Filter_Not_Apply'): filtersSHEET.licensePlateSheetFrom}
                    </li>
                    <div className={filtersSHEET.licensePlateSheetTo===''?"sidebar-heading":"sidebar-heading text-white"}>   
                        {t('Text_Filter_LicensePlateSheet_To')}
                    </div>
                    <li className={filtersSHEET.licensePlateSheetTo===''?"sidebar-heading text-warning":"sidebar-heading text-warning"}>
                        { filtersSHEET.licensePlateSheetTo==='' ? t('Text_Filter_Not_Apply'): filtersSHEET.licensePlateSheetTo}
                    </li>

                    <div className={filtersSHEET.frameSheetFrom===''?"sidebar-heading":"sidebar-heading text-white"}>   
                        {t('Text_Filter_FrameSheet_From')}
                    </div>
                    <li className={filtersSHEET.frameSheetFrom===''?"sidebar-heading text-warning":"sidebar-heading text-warning"}>
                        { filtersSHEET.frameSheetFrom==='' ? t('Text_Filter_Not_Apply'): filtersSHEET.frameSheetFrom}
                    </li>
                    <div className={filtersSHEET.frameSheetTo===''?"sidebar-heading":"sidebar-heading text-white"}>   
                        {t('Text_Filter_FrameSheet_To')}
                    </div>
                    <li className={filtersSHEET.frameSheetTo===''?"sidebar-heading text-warning":"sidebar-heading text-warning"}>
                        { filtersSHEET.frameSheetTo==='' ? t('Text_Filter_Not_Apply'): filtersSHEET.frameSheetTo}
                    </li>

                    <div className={(filtersSHEET.sheetStateFromEN==='' && filtersSHEET.sheetStateFromES==='')?"sidebar-heading":"sidebar-heading text-white"}>
                        {t('Text_Filter_SheetStatus_From')}
                    </div>
                    <li className="sidebar-heading text-warning">
                        { i18n.language==="en"?filtersSHEET.sheetStateFromEN==='' ? t('Text_Filter_Not_Apply'): filtersSHEET.sheetStateFromEN:filtersSHEET.sheetStateFromES==='' ? t('Text_Filter_Not_Apply'): filtersSHEET.sheetStateFromES}
                    </li>
                    <div className={(filtersSHEET.sheetStateToEN==='' && filtersSHEET.sheetStateToES==='')?"sidebar-heading":"sidebar-heading text-white"}>
                        {t('Text_Filter_SheetStatus_To')}
                    </div>
                    <li className="sidebar-heading text-warning">
                        { i18n.language==="en"?filtersSHEET.sheetStateToEN==='' ? t('Text_Filter_Not_Apply'): filtersSHEET.sheetStateToEN:filtersSHEET.sheetStateToES==='' ? t('Text_Filter_Not_Apply'): filtersSHEET.sheetStateToES}
                    </li>
                     

                    <li className="sidebar-heading text-warning">
                    &nbsp;
                    </li>
                    {/* Divider */}
                    <hr className="sidebar-divider"/>

                    {/* Heading */}
                    {/* Nav Item - Admin Collapse Menu */}
                    {roles[0].listmenus.find((key)=>(key.name==="Menu_Settings"))&&
                        <li className="nav-item">
                            <Link className="nav-link collapsed" to="/sheet" data-toggle="collapse" data-target="#collapseAdmin"
                                aria-expanded="true" aria-controls="collapseAdmin">
                                <SettingsIcon/>
                                <span>{t('Menu_Settings')}</span>
                            </Link>
                            <div id="collapseAdmin" className="collapse" aria-labelledby="headingAdmin"
                                data-parent="#accordionSidebar">
                                <div className="bg-white py-2 collapse-inner rounded">
                                    <h6 className="collapse-header">{t('Custom_Menu_Settings')}</h6>
                                    <Link className="collapse-item" to="/sheet" onClick={changeSelectedLanguage}>{i18n.language==="es"?t('SubMenu_Settings_ChangeToEnglish'):t('SubMenu_Settings_ChangeToSpanish')}</Link>
                                </div>
                            </div>
                        </li>
                    }
                    {/* Nav Item - Charts */}                  
                    <li className="nav-item">
                        <Link className="nav-link" to="/home" onClick={closeModalSHEET} >
                            <LogoutIcon/>
                            <span>{t('Button_Back')}</span>
                        </Link>
                    </li>

                    {/* Divider */}
                    <hr className="sidebar-divider d-none d-md-block"/>

                    {/* Sidebar Toggler (Sidebar) */}
                    <div className="text-center d-none d-md-inline">
                        <button className="rounded-circle border-0" id="sidebarToggle"></button>
                    </div>

          
                </ul>
                {/* End of Sidebar */}

                {/* Content Wrapper */}
                <div id="content-wrapper" className="d-flex flex-column">

                {/* Main Content */}
                <div id="content">

                    {/* Topbar  */}
                    <nav className="navbar navbar-expand navbar-light bg-white topbar mb-4 static-top shadow">

                        {/* Sidebar Toggle (Topbar)  */}
                        <button id="sidebarToggleTop" className="btn btn-link d-md-none rounded-circle mr-3">
                            <i className="fa fa-bars"></i>
                        </button>
                        
                        {/* Topbar Navbar */}
                        <ul className="navbar-nav ml-auto">
                            <Person/>
                            <div className="topbar-divider d-none d-sm-block"></div>
                                <div className="driver-name-ok">
                                    <br/>
                                    {t('Text_StoreSelected')}&nbsp;{ defaultStore.tradename===null ? t('Text_StoreEmpty'):defaultStore.tradename }
                                </div>   
                            <div className="topbar-divider d-none d-sm-block"></div>
                            {/* Nav Item - Alerts */}
                            <Alerts/>
                            {/* Nav Item - Messages */}
                            <Messages/>
                            <div className="topbar-divider d-none d-sm-block"></div>
                            {/* Nav Item - User Information */}
                            <li className="nav-item dropdown no-arrow mx-1">
                                <br/>
                                <span className="mr-2 d-none d-lg-inline text-gray-600 small">
                                    <TodayIs/>  
                                </span>
                            </li>
                        </ul>
                    </nav>
                    {/* End of Topbar */}

                {/* Show Modals */}  
                <SHEETFilter 
                    showModalSHEEETSettings={showModalSHEEETSettings} 
                    typeOfList={typeOfList.typeList}
                />
                 
                </div>
                {/* End of Main Content */}

                {/* Footer */}
                <Footer/>
                {/* End of Footer */}

            </div>
            {/* End of Content Wrapper */}

          </div>
          {/* End of Page Wrapper */}
         
      </div>}
      {/* End of Body */}

    </>
  )
};

export default HomeSHEET;
